export const elements_classes = {
    data(){
        return{
            this_page_name: ''
        }
    },
    methods:{

    },
    mounted(){

        this.this_page_name = this.this_page

        $('body').addClass(this.this_page_name + '--body')
        $('#front-app').addClass(this.this_page_name + '--app')

        $('.main-container').addClass('main-container--'+this.this_page_name)
        $('button').addClass('button--'+this.this_page_name)

    },
    beforeDestroy(){
            $('body').removeClass(this.this_page_name + '--body')
            $('#front-app').removeClass(this.this_page_name + '--app')

    }

}